<template>
  <div class="d-flex justify-content-between align-items-center">
    <p class="clearfix mb-0">
      <span
        class="float-md-left d-block d-md-inline-block mt-25"
      >{{ $t('COPYRIGHT') }} &copy; {{ new Date().getFullYear() }} <span class="logo-start">Udara</span><span class="logo-end">360</span>
        <span>, {{ $t('All rights Reserved') }} | v{{ packageJson.version }}</span>
      </span>
    </p>

    <!-- Only show update button when updates are available -->
    <b-button
      v-if="hasUpdateAvailable"
      variant="primary"
      size="sm"
      :disabled="isUpdating"
      class="d-none d-md-block update-app-button"
      @click="updateApp"
    >
      <b-spinner
        v-if="isUpdating"
        small
        class="mr-1"
      />
      <feather-icon
        v-else
        icon="RefreshCwIcon"
        size="14"
        class="mr-1"
      />
      {{ isUpdating ? 'Refreshing...' : 'Refresh' }}
    </b-button>

    <!-- Manual check button - only show when no updates are available -->
    <!-- <b-button
      v-else
      variant="outline-primary"
      size="sm"
      :disabled="isChecking"
      class="d-none d-md-block"
      @click="manualDeploymentCheck"
    >
      <b-spinner
        v-if="isChecking"
        small
        class="mr-1"
      />
      <feather-icon
        v-else
        icon="RefreshCcwIcon"
        size="14"
      />
      {{ isChecking ? 'Checking...' : 'Check for updates' }}
    </b-button> -->
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import packageJson from '../../../../package.json'
import deploymentDetector from '@/utils/deploymentDetector'

export default {
  components: {
    BButton,
    BSpinner,
  },
  data() {
    return {
      packageJson,
      isChecking: false,
      isUpdating: false,
      hasUpdateAvailable: false,
    }
  },
  mounted() {
    // Register for update notifications
    deploymentDetector.onUpdateAvailable(this.handleUpdateAvailable)

    // Check current state
    this.hasUpdateAvailable = deploymentDetector.hasNewDeployment

    // Start periodic checking for updates
    deploymentDetector.manualCheck()
  },
  beforeDestroy() {
    // Clean up if needed
    deploymentDetector.destroy()
  },
  methods: {
    handleUpdateAvailable(hasUpdate) {
      this.hasUpdateAvailable = hasUpdate
      console.log('Update availability changed:', hasUpdate)
    },

    async updateApp() {
      this.isUpdating = true

      try {
        await deploymentDetector.refreshApplication()
      } catch (error) {
        console.error('Error updating app:', error)
        // Fallback refresh
        window.location.reload()
      }
    },

    async manualDeploymentCheck() {
      console.log('Manual deployment check started')
      this.isChecking = true

      try {
        // Add a minimum delay to ensure spinner is visible
        const checkPromise = deploymentDetector.manualCheck()
        const minDelayPromise = new Promise(resolve => setTimeout(resolve, 1000)) // 1 second minimum

        await Promise.all([checkPromise, minDelayPromise])
        console.log('Manual deployment check completed')
      } catch (error) {
        console.error('Error checking for deployment:', error)
      } finally {
        this.isChecking = false
        console.log('Manual deployment check finished, spinner hidden')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  &-start {
    color: #81bf42;
  }
  &-end {
    color: #f26333;
  }
}

.update-app-button {
  animation: subtle-pulse 2s infinite;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--primary) 30%, transparent);
}

@keyframes subtle-pulse {
  0% {
    box-shadow: 0 2px 8px color-mix(in srgb, var(--primary) 30%, transparent);
  }
  50% {
    box-shadow: 0 4px 16px color-mix(in srgb, var(--primary) 40%, transparent);
  }
  100% {
    box-shadow: 0 2px 8px color-mix(in srgb, var(--primary) 30%, transparent);
  }
}
</style>
